export default __webpack_public_path__ + "static/media/profileDummy.7de99e7d.png";